import { useId } from 'react'
import { clsx } from 'clsx'

/**
 * GlobalX mark: a globe wrapped by a gold orbit that draws a "G",
 * whose tail rises as an arrow (growth). Pure SVG, scales to any size.
 */
export function LogoMark({ className, title }: { className?: string; title?: string }) {
  const id = useId().replace(/:/g, '')
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <defs>
        <radialGradient id={`${id}-globe`} cx="38%" cy="32%" r="75%">
          <stop offset="0%" stopColor="#5b8cff" />
          <stop offset="45%" stopColor="#1f4fd1" />
          <stop offset="100%" stopColor="#071a4d" />
        </radialGradient>
        <linearGradient id={`${id}-gold`} x1="8" y1="8" x2="58" y2="58" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#fbe7b0" />
          <stop offset="40%" stopColor="#e8bd5c" />
          <stop offset="75%" stopColor="#d4a03c" />
          <stop offset="100%" stopColor="#9c7020" />
        </linearGradient>
        <clipPath id={`${id}-clip`}>
          <circle cx="32" cy="33" r="19" />
        </clipPath>
      </defs>
      <circle cx="32" cy="33" r="19" fill={`url(#${id}-globe)`} />
      <g clipPath={`url(#${id}-clip)`} fill="none" stroke="#bcd0ff" strokeOpacity="0.45" strokeWidth="1">
        <ellipse cx="32" cy="33" rx="8" ry="19" />
        <ellipse cx="32" cy="33" rx="15" ry="19" />
        <line x1="13" y1="33" x2="51" y2="33" />
        <path d="M14 25 Q32 21 50 25" />
        <path d="M14 41 Q32 45 50 41" />
      </g>
      {/* Gold "G" orbit: open on the upper right, with the crossbar entering the globe. */}
      <path
        d="M49.5 15.5 A25 25 0 1 0 57 33 L41 33"
        fill="none"
        stroke={`url(#${id}-gold)`}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Rising arrow tip at the start of the orbit. */}
      <path d="M44.2 7.6 L55.6 8.6 L54.4 20 Z" fill={`url(#${id}-gold)`} />
    </svg>
  )
}

export function Logo({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <span className={clsx('inline-flex items-center gap-2.5 ltr', className)}>
      <LogoMark className="size-9 shrink-0 drop-shadow-[0_4px_12px_rgb(232_189_92/0.25)]" />
      {!compact && (
        <span className="text-[1.35rem] leading-none font-bold tracking-[-0.03em]">
          <span className="text-fg">Global</span>
          <span className="gold-text">X</span>
        </span>
      )}
    </span>
  )
}
